import { Language } from '@coolblue-development/constants';
export default class I18nInstanceRepository {
    static getInstance(language) {
        var _a;
        const instances = I18nInstanceRepository.getInstances();
        return (_a = instances[language]) !== null && _a !== void 0 ? _a : null;
    }
    static storeInstance(instance, language) {
        const instances = I18nInstanceRepository.getInstances();
        instances[language] = instance;
    }
    static getInstances() {
        var _a;
        return (_a = global.i18nInstanceMap) !== null && _a !== void 0 ? _a : I18nInstanceRepository.getEmptyInstanceMap();
    }
    static getEmptyInstanceMap() {
        return {
            [Language.DUTCH]: null,
            [Language.ENGLISH]: null,
            [Language.FRENCH]: null,
            [Language.GERMAN]: null,
        };
    }
}
//# sourceMappingURL=I18nInstanceRepository.js.map